import { render, staticRenderFns } from "./cooperation.vue?vue&type=template&id=dc1c7f28&scoped=true&"
import script from "./cooperation.vue?vue&type=script&lang=js&"
export * from "./cooperation.vue?vue&type=script&lang=js&"
import style0 from "./cooperation.vue?vue&type=style&index=0&id=dc1c7f28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc1c7f28",
  null
  
)

export default component.exports